import type { PropTypes } from './ProfileUserDataEmptyState.types';
import type { ReactElement } from 'react';

import { Flex, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { dispatchCancellableAction, fetchProfileDetails } from '../../../state/ProfileSlice';
import { UnexpectedError } from '../UnexpectedError';

import styles from './ProfileUserDataEmptyState.module.css';

export function ProfileUserDataEmptyState(props: PropTypes): ReactElement {
  const { error, defaultMessage, image = '/imgs/illustrations/empty' } = props;
  const { t } = useTranslation();
  const params = useParams<{ username: string }>();
  const { isDarkMode } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const refetchProfileDetails = () => {
    if (params.username) {
      dispatchCancellableAction(dispatch, fetchProfileDetails);
    }
  };

  if (error) {
    return (
      <Flex direction="column" align="center" justify="center" py="7">
        <UnexpectedError context="profile-page-user-data" onRetry={refetchProfileDetails} />
      </Flex>
    );
  }

  const emptyImage = `${image}-${isDarkMode ? 'dark' : 'light'}.svg`;

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="6"
      py={{ initial: '64px', md: '125px' }}>
      <img src={emptyImage} alt="no data" className={styles.image} />
      <Text size="2" weight="medium" color="gray" align="center">
        {defaultMessage ??
          t('There is no data here right now. Please swap first to see the details.')}
      </Text>
    </Flex>
  );
}
